import React from 'react';
import PropTypes from 'prop-types';
import '@streaming/jink-player/dist/jink-player.min.css';

import ConditionalComponent from 'components/ConditionalComponent/ConditionalComponent';

import JinkPlayerContainer from './JinkPlayerContainer';
import MigratedPlayerContainer from './MigrationFactory/MigratedPlayerContainer';
// eslint-disable-next-line import/no-restricted-paths
import SmartxPlayer from './SmartXPlayer/SmartxPlayer';
import resolveIsJinkPlayerShouldBeUsed from './common/resolveIsJinkPlayerShouldBeUsed';

/**
 *
 * Temporary safe-conditional player that will render original SmartxPlayer OR new JinkPlayer
 * based on the feature flags OR localStorage value
 *
 */

const JinkPlayerWrap = ({ forceRemountOnError, ...props }) => (
  <MigratedPlayerContainer
    key={props?.source?.uri || Date.now()}
    {...props}
    PlayerComponent={JinkPlayerContainer}
    forceRemountOnError={forceRemountOnError}
    isJinkPlayer={true}
  />
);

JinkPlayerWrap.propTypes = {
  forceRemountOnError: PropTypes.func.isRequired,
  source: PropTypes.object,
};

JinkPlayerWrap.defaultProps = { source: undefined };

const SmartxPlayerWrap = (props) => (
  <MigratedPlayerContainer {...props} PlayerComponent={SmartxPlayer} isJinkPlayer={false} />
);

class ConditionalSmartxPlayer extends React.Component {
  render() {
    return (
      <ConditionalComponent
        {...this.props}
        BaseComponent={SmartxPlayerWrap}
        NewComponent={JinkPlayerWrap}
        allowRemountOnCrash={true}
        conditionFunc={resolveIsJinkPlayerShouldBeUsed}
      />
    );
  }
}

ConditionalSmartxPlayer.propTypes = {
  // eslint-disable-next-line react/forbid-foreign-prop-types
  ...SmartxPlayer.propTypes,
  forceRemountOnError: PropTypes.func,
  source: PropTypes.shape({
    type: PropTypes.oneOf(['HLS']),
    uri: PropTypes.string,
  }),
};

ConditionalSmartxPlayer.defaultProps = {
  ...SmartxPlayer.defaultProps,
  source: {
    type: 'HLS',
    uri: SmartxPlayer.defaultProps.source,
  },
};

export default ConditionalSmartxPlayer;
